/**
 * QuickCheckinWidget - Widget dashboard compatto per Quick Check-in
 * Il Diario di Bordo - SaaS
 */

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFeature } from '../../hooks/useFeature'
import { minoriApi } from '../../services/api'
import { Zap, ArrowRight } from 'lucide-react'

const extractMinori = (response) => {
  const data = response?.data
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.data)) return data.data
  if (Array.isArray(data?.minori)) return data.minori
  if (Array.isArray(data?.data?.minori)) return data.data.minori
  return []
}

export default function QuickCheckinWidget() {
  const { visible } = useFeature('quickCheckin')
  const navigate = useNavigate()
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!visible) return
    minoriApi.list({ attivo: true })
      .then(res => setCount(extractMinori(res).length))
      .catch(() => {})
  }, [visible])

  if (!visible) return null

  return (
    <div
      onClick={() => navigate('/checkin')}
      className="card p-4 cursor-pointer hover:shadow-md transition-shadow group"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg mr-3 group-hover:bg-amber-200 dark:group-hover:bg-amber-800/40 transition-colors">
            <Zap className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white text-sm">Quick Check-in</h3>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {count} minori attivi
            </p>
          </div>
        </div>
        <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-primary-600 transition-colors" />
      </div>
    </div>
  )
}
